export interface AuthenticationState {
  data?: Authentication;
  loading?: boolean;
  error?: string;
  flow: AuthFlow;
  signUpEmail?: string;
  resetRequestValidated?: boolean;
}

export enum AuthFlow {
  FORCE = 'FORCE',
  SKIP = 'SKIP',
  DONE = 'DONE'
}


export interface Authentication {
  userId: number;
  avatar?: string;
  email?: string;
  name?: string;
  sessionId?: string;
  expiresAt?: string;
  redirect?: {email: string}
}

export interface SignUpRequest {
  name: string;
  surname: string;
  company: string;
  email: string;
  password: string;
  passwordValidation: string;
  isCompany: boolean;
  country: {id: number; label?: string};
  city: string;
  zip: string;
  policy: [],
  lang: string;
}

export interface LoginRequest {
  login: string;
  password: string;
}


export interface SignUpResponse {
  result?: any;
  error?: any;
}
